<script>

import Layout from "../../layouts/main";
import ItemsApi from "@/services/items-api";
import ColorComponent from "@/components/ColorComponent.vue"
import SizeComponent from "@/components/sizeComponent.vue"
import productCardInproductPage from "@/components/productCardInproductPage.vue"
import Navigation from "@/components/navigation.vue"
import LookMenu from "@/components/look-menu.vue"
import WishList from "@/services/wishlist-api";
import GiftApi from "@/services/gift-api";
import SizeGuide from "@/components/size-guide.vue"
import StarRating from 'vue-star-rating'
import Vue from 'vue'
import ProductCard from "@/components/productCard.vue"
import ProuductPageInfo from "@/components/product-page-info.vue"



import vueCustomScrollbar from 'vue-custom-scrollbar'
import "vue-custom-scrollbar/dist/vueScrollbar.css"

export default ({
    name: "ProductPage",
    page: {
    titleTemplate(title) {

       
       let pageTitle = this.$route.params.ignored;
       
        pageTitle = pageTitle.replace(/-/g, ' ');
        return pageTitle ? pageTitle.replace(/\b\w/g, char => char.toUpperCase()) + ' | HA, Boutique en ligne, Tunisie' : title;
    }
  },

    components: {
        Layout, ColorComponent,SizeComponent, productCardInproductPage ,Navigation , LookMenu, vueCustomScrollbar, SizeGuide, StarRating, ProductCard, ProuductPageInfo
    },
    data() {
        return {
            
            equivalentPagemodel: {currentPage : 1, perPage : 4, totalRows: 0 , maxPagesCount: 0},
            complementPagemodel: {currentPage : 1, perPage : 4, totalRows: 0 , maxPagesCount: 0},


            showZoomImage : false ,
            selectedColor: null,
            selectedSize: null,
            quantity: 1,
            prevY: 0,
            itemVariantIndex : 0 ,
            listVariant : null ,
        
            product: {priceDiscounted : null , isInWishList: null} ,

            selectedItemVariantId: null,
            selectedSectionName: null,
            selectedGroupName: null,
            selectedSubGroupName: null,
            selectedItem: null,
            urlImage : null ,

            section: null,
            group: null,
            subGroup: null,

            complementItems: null ,
            equivalentItems: null ,
            isGetComplementItemsStarting:false ,
            isGetEquivalentItemsStarting:false ,

            showAllLook: false ,

            showSelectSizeColorMsg: false,

            horizontalImageReachedEnd: false,

            scrollSettings: { wheelPropagation: true, useBothWheelAxes:true },

            showSizeGuide: false,

            ratings: null,

            isRatingSelected: false,
            selectedRating: null,

            hdImageLoaded: {},

            isHdBigImageLoaded: false,

            isShowProductRefInMobile: false,
        };
    },

    computed: {
        getImages() {
            if (!this.product || !this.product.sizes) {
                return null;
            }
            const colorId = this.selectedColor ? this.selectedColor.color.id :   (  this.product.color ? this.product.color.id : null ) ;
            const data = this.product.sizes;

            const imagesSet = new Set();

            for (const size in data) {
                for (const item of data[size]) {
                    if (colorId === null || (item.color && item.color.id === colorId)) {
                        if (item.itemsVariantImages) {
                            item.itemsVariantImages.forEach(image => imagesSet.add(image));
                        }
                    }
                }
            }


            //if variant have no images, then take the first variant images
            if (!imagesSet.size) {
                for (const size in data) {
                    for (const item of data[size]) {
                        if (item.itemsVariantImages) {
                            item.itemsVariantImages.forEach(image => imagesSet.add(image));

                            break;
                        }
                    }
                }
            }

            return imagesSet;
        },

        getVideos() {
        
            if (!this.product || !this.product.sizes) {
                return null;
            }
            const colorId = this.selectedColor ? this.selectedColor.color.id : null;
            const data = this.product.sizes;
            const videoSet = new Set();
                        for (const size in data) {
                    for (const item of data[size]) {
                        if (colorId === null || (item.color && item.color.id === colorId)) {
                            if (item.itemsVariantVideos) {
                                item.itemsVariantVideos.forEach(video => videoSet.add(video));
                            }
                
                        }
                    }
            }
            return videoSet ;
    },

    ItemVariantId() {
        return (colorId , size) => {

            if (!this.product || !this.product.sizes) {
                return null;
            }

            const data = this.product.sizes;
                let itemvariantId =0; // Using Set to store distinct images
               
                    for (const item of data[size]) {
                        if (colorId === null || (item.color && item.color.id === colorId)) {
                            itemvariantId = item.id
                        }
                    }
            

            return itemvariantId;
        };
    },
    currentUser() {
        return this.$store.getters['auth/currentUser'];
    },

    userFullName() {
         return this.currentUser && this.currentUser.fullName ? this.currentUser.fullName : '';
        },


    currentUrl() {
          return encodeURIComponent(window.location.href);
    },

    isShowRating() {
        return this.isRatingSelected && this.product && this.product.showRating;
    }

},

    mounted(){

      if (window.innerWidth <= 768) {
        this.equivalentPagemodel = {currentPage : 1, perPage : 1, totalRows: 0 , maxPagesCount: 0};
        this.complementPagemodel = {currentPage : 1, perPage : 1, totalRows: 0 , maxPagesCount: 0};
      }

      this.getComplementItems(this.selectedItem)
      this.getEquivalentItems(this.selectedItem)
    },

    methods: {
        checkGiftByItemRef(){
            GiftApi.checkGiftByItemRef(this.product.ref).then((giftCode)=>{
                if(giftCode){
                    this.$store.commit('setGiftCode', giftCode);
                }
            })
        },


        setVisitItem(){
            const isProductDetailsScreen = 1
            ItemsApi.setVisitItem(this.product.id ,isProductDetailsScreen)
        },

        beforeEnter(el) {
          el.style.widht = '0px';
        },
        enter(el) {
         el.style.widht = el.scrollWidht + 'px';
        },
        leave(el) {
          el.style.widht = '0px';
        },

        showLook(){
            this.showAllLook = true ;
        },

        closeDropdownMethod() {
        this.showAllLook = false;
        },

        addToWishList(){

            if (!this.currentUser) {
                Vue.prototype.$snotify.simple("Vous devez être connecté pour gérer votre wishlist");
                return;
            }

            if(!this.selectedItemVariantId){
                Vue.prototype.$snotify.simple("Vous devez sélectionner une couleur et une taille");
                return;
            }
            
            WishList.addToWishlist(this.selectedItemVariantId).then(
            (result) =>{
                if(result){
                    this.product.isInWishList = true
                }
            } 
            )  
           
            },

            removeWishListByItem(){
            WishList.removeWishListByItem(this.product.id).then(
                (result) =>{
                    if(result){
                        this.product.isInWishList = false
                    }
                } 
            )  

            },

        addToCart(){

            if (!this.selectedItemVariantId) {
                this.showSelectSizeColorMsg=true;
                return;
            }

             this.$store.dispatch('addToCart', [{ itemVariantId: this.selectedItemVariantId, quantity: this.quantity }])
         },

        getEquivalentItems(itemRef){
            this.isGetEquivalentItemsStarting= true
            ItemsApi.getSimilairItems(this.equivalentPagemodel.currentPage, this.equivalentPagemodel.perPage, itemRef).then(
                (result) => {

                    if (result) {
                        this.equivalentItems=result.list;
                        this.equivalentPagemodel.totalRows = result.total;
                        this.equivalentPagemodel.maxPagesCount = result.maxPagesCount ;
                    }

                    
                }
            ).finally(()=>{
                this.isGetEquivalentItemsStarting=false
            })
      }, 
        
      getComplementItems(itemRef) {
        this.isGetComplementItemsStarting = true;
        ItemsApi.getComplementItemsForHome(this.complementPagemodel.currentPage, this.complementPagemodel.perPage, itemRef)
            .then(result => {

                if (result) {
                    this.complementItems = result.list;
                this.complementPagemodel.totalRows = result.total;
                this.complementPagemodel.currentPage = result.page;
                this.complementPagemodel.maxPagesCount = result.maxPagesCount ;
                }

                


                              
            })
            .finally(() => {
                this.isGetComplementItemsStarting = false;
            });
    },

    nextPage(items) {
     

            if(this.complementItems == items){
                this.complementPagemodel.currentPage++;
                this.getComplementItems(this.selectedItem)
            }
            if(this.equivalentItems == items){
                this.equivalentPagemodel.currentPage++;
                this.getEquivalentItems(this.selectedItem)
            }
    },

    previousPage(items) {
            if(this.complementItems == items){
                this.complementPagemodel.currentPage--;
                this.getComplementItems(this.selectedItem)
            }
            if(this.equivalentItems == items){
                this.equivalentPagemodel.currentPage--;
                this.getEquivalentItems(this.selectedItem)
            }
    },
      
         

         findItem() {
            this.showItemsSpinner = true;
            ItemsApi.findItem(this.selectedItem,  this.selectedSectionName, this.selectedGroupName, this.selectedSubGroupName)
                .then(itemsList => {

                    if(itemsList && itemsList.list && itemsList.list.length > 0){
                        this.product = itemsList.list[0];   
                        this.section = itemsList.section;
                        this.group = itemsList.group;
                        this.subGroup = itemsList.subGroup;
                       
                       //TODO this was used to set default color, can be removed later
                       // this.selectedColor = { color: this.product.color };

                        this.getRatings();
                        this.setVisitItem();
                        this.checkGiftByItemRef()

                        if (this.product && this.product.title) {
                            document.title = this.product.title + ' | HA, Boutique en ligne, Tunisie';
                        }


                    } else {

                        this.$router.push({ path: "/404" }
                    );
                    }
                })
                .finally(() => {
                    this.showItemsSpinner = false;
                })
        }, 

        updateSelectedColor(color) { 
            this.selectedColor = color ? color : null /*: {color: this.product.color}*/ ;
            this.showSelectSizeColorMsg=false;

        },

        updateSelectedSize(size) {
            this.selectedSize = size;
            this.showSelectSizeColorMsg=false;

        },

        incrementQuantity() {
            this.quantity++;
        },
        decrementQuantity() {
            if (this.quantity > 1) {
                this.quantity--;
            }
        },

       /* handleMouseMove(event) {
                const deltaY =event.clientY  - this.prevY   ;
                const activeElement = this.$el.querySelector('.active-big-image');

                

                const viewportHeight =  window.outerHeight;
                //document.documentElement.clientHeight;
                //window.innerHeight;
                //console.log('vh: ' +viewportHeight)

                let scrollPercent = (deltaY/ viewportHeight) * 100;
                if (scrollPercent > 70) {
                    scrollPercent = 130
                }

                if (scrollPercent < 20) {
                    scrollPercent = 0
                }
                console.log (scrollPercent)
                
                if (scrollPercent <= 130) {
                    activeElement.style.top = (scrollPercent * -1) + '%'; 
                    //-( deltaY *3)  + 'px';   
                }

                //console.log('top: ' + activeElement.style.top)

                //console.log("cy: "+ event.clientY)
                //this.prevY = event.clientY;
                //console.log("py: "+ this.prevY)

        },*/

        handleMouseMove(/*event*/) {
            /*const container = this.$el.querySelector('.image-zoom-container');
            const mouseY = event.clientY;
            const containerHeight = container.clientHeight;
            const scrollHeight = container.scrollHeight;

            // Calculate the percentage of mouse position relative to container height
            const scrollPercentage = mouseY / containerHeight;

            // Calculate the scrollTop position based on the scrollPercentage
            const scrollTop = scrollPercentage * (scrollHeight - containerHeight);

            // Set the scrollTop of the container
            container.scrollTop = scrollTop;*/
        },





       

        onZoomKeyDown(event) {
            if (event.keyCode === 27) { 
                this.showZoomImage = false;
            }
        },

        openBigImage(itemImage){
            this.isHdBigImageLoaded = false;
            this.showZoomImage = true
            this.urlImage = itemImage 

            this.$nextTick(() => {
                this.$refs.zoomDiv.focus();
            });

        },

        onScrollMouseLeave() {
            this.scrollSettings.useBothWheelAxes=true;
            this.horizontalImageReachedEnd=false;
        },

        onScrollMouseEnter () {
            this.scrollSettings.useBothWheelAxes=true;
        },

        onImageWheel(e) {
            //TODO if the scroll is not visible then not prevent default !!!
            if (!this.horizontalImageReachedEnd) {
                e.preventDefault();
           }            
        },

        onImageScrollEnd() {            
            if (!this.horizontalImageReachedEnd) {
                this.scrollSettings.useBothWheelAxes=false;
                this.horizontalImageReachedEnd=true;
            }
        },

        onImageScrollStart() {
            this.horizontalImageReachedEnd=false;
            this.scrollSettings.useBothWheelAxes=true;

        },

        onImageScroll() {
            this.horizontalImageReachedEnd=false;
            this.scrollSettings.useBothWheelAxes=true;
        },

        addTocompare(itemRef){
            this.$store.dispatch('addToComparator', itemRef)
        },

        showInfo() {
            this.isShowProductRefInMobile = !this.isShowProductRefInMobile;
            this.isRatingSelected = false;
        },

        showRating() {
            this.isRatingSelected = !this.isRatingSelected;
        },

        getRatings() {

            if (!this.product) {
                return;
            }

            ItemsApi.getRatings(this.product.id).then(
                (result) => {
                    this.ratings=result ? result : {rating: null, ratingVerified: null, connectedUserRating: null};
                    this.selectedRating = this.ratings ? this.ratings.connectedUserRating : null;
                }
            ).finally(()=>{
                
            })
        },

        onHdImageLoad(image) {
            if (!image) {
                return;
            }
            this.$set(this.hdImageLoaded, image, true);
        },

        onHdBigImageLoad() {
            this.isHdBigImageLoaded = true;
        }

  
    },

    watch :{

    '$route': {
        immediate: true,
        deep: true, 
        handler(route) {
            this.selectedSectionName  = route.params.section;
            this.selectedGroupName    = route.params.group;
            this.selectedSubGroupName = route.params.subgroup;

            this.selectedItem = route.params.item;


            this.findItem();
        }
    },


    selectedColor(newValue) {
      if(this.selectedSize && newValue){
        this.selectedItemVariantId = this.ItemVariantId(newValue.color.id , this.selectedSize)
      }else{
        this.selectedItemVariantId = null
      }

    },
    selectedSize(newValue) {
        if(this.selectedColor && newValue){
            this.selectedItemVariantId =  this.ItemVariantId(this.selectedColor.color.id , newValue)
        }else{
        this.selectedItemVariantId = null
      }

    },

    selectedRating() {
        if (!this.product || !this.selectedRating) {
            return;
        }

        ItemsApi.addRating(this.product.id, this.selectedRating).then(
            (result) => {
                this.ratings=result;
                this.selectedRating = this.ratings ? this.ratings.connectedUserRating : null;
            }
        )
    }

},


})
</script>

<template>
    <Layout class="m-2 m-xl-0">

        <transition name="slide" 
            @before-enter="beforeEnter"
            @enter="enter"
            @leave="leave"
      >
            <LookMenu v-if="showAllLook" @close="closeDropdownMethod" :itemRef="product.ref"  ></LookMenu>
    </transition>

    

    <vue-custom-scrollbar  v-if="getImages" class="d-none d-xl-block scroll-area images-zone-size" ref="scrollbar"  :settings="scrollSettings" @wheel.native="onImageWheel"  
             @ps-scroll-x="onImageScroll"     @ps-x-reach-end="onImageScrollEnd"                               
                style="position: sticky; 
                width: 100%;
                overflow-y: hidden; overflow-x: auto;">

        <div @mouseleave="onScrollMouseLeave" @mouseenter="onScrollMouseEnter"  style="position: absolute; height: 100%; will-change: transform;"> 
            <ul class="multimedia-list-container" style="position: relative;
    height: 100%;
    padding: 0px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    column-gap: 0px;
    align-items: center;">
        <li v-for="(video, index) in  getVideos"  :key="index" class="multimedia-item image" style="position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-width: fit-content;
    margin: 0 0px;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0px;
    border-color: transparent;
    transition: border-color .3s ease-out;
    cursor: pointer;
    user-select: none;">
        <video width="100%" height="100%" class="banner-video-mobile" loop playsinline autoplay muted >
            <source :src="'/api/image/get/'+video" type="video/mp4" >
        </video>	

            </li>
        
          <li v-for="image in  getImages"  :key="image.id" class="multimedia-item image" @click="openBigImage(image ? image : null)" style="position: relative;
          
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
                min-width: fit-content;
                margin: 0 0px;
                overflow: hidden;
                box-sizing: border-box;
                padding: 0px;
                border-color: transparent;
                transition: border-color .3s ease-out;
                cursor: pointer;
                user-select: none;">       
<div   class="image-container"> 
            <img v-show="image && hdImageLoaded[image]" class="product-image"  v-bind:src="'/api/image/get/product/' + (image ? image : null)"  @load="onHdImageLoad(image)" />
            <img v-show="image && !hdImageLoaded[image]" class="product-image"  v-bind:src="'/api/image/get/product/small/' + (image ? image : null)"  />

            <!-- <div v-if="!hdImageLoaded[image]" class="spinner-container">
                <b-spinner class="m-2" variant="white" role="status"></b-spinner>
            </div> -->

        <div class="icon-container" @click="openBigImage(image ? image : null)" >
            <img src="@/assets/images/search-white.png" width="35px" height="35px" >
        </div>
    </div>

                </li>
            </ul>
        </div>


    <!-- </div> -->

    </vue-custom-scrollbar>


    <div class="d-none d-xl-block bottom-info-container title-zone-size"   style="transition: all .5s; z-index:990; 
    box-shadow: 0px -10px 15px 0px #0000001A;
    transform: translateY(0);
    position: relative;
    bottom: 0;
    left: 0;
    
    width: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    padding: 0 40px;"   >

            <div class="row  w-100 h-100 pt-3" style="overflow:hidden !important;">
                
                <div class="col-12 col-lg-4">

                    <div class="row pb-2">
                        <div class="col-10 titleClass"> {{ product ? product.title : '' }} </div>
                        <div class="col-2 pt-2 ">
                            <img v-if="!this.currentUser || product && product.isInWishList == false" width="20px"  :title="this.currentUser ? 'Ajouter à votre wishlist' : 'Vous devez vous connecter pour gérer votre wishlist'"  alt="" src="../../../assets/icons/heart.svg" style="cursor:pointer;" @click="addToWishList()" />
                            <img v-if="this.currentUser && product && product.isInWishList == true" alt="" width="20px" src="@/assets/icons/heart-red.svg" style="cursor:pointer;" @click="removeWishListByItem()"/>
                        </div>
                    </div>
                    <div class="row pb-2">

                        <div class="col-12 price font-weight-bold">
                            <span style="font-size:26px;">{{ product && product.priceDiscounted ? product.priceDiscounted : '' }} </span>
                            <span v-if="product && product.discount" 
                                class="ml-1 line-through font-size-20 text-secondary" >{{ product.price }}</span>  
                            <span v-if="product && product.discount" class="ml-3 discountLabel-max">{{ product.discountStr }}</span>
                        </div>
                    
                    </div>
                    <div class="d-none d-md-block mt-2">

                        <div class="row pb-2 ">


                                <div title="Ajouter au comparateur" class="compare-wrapper" @click="addTocompare(product.ref)">
                                    
                                    <img class="compareIcon" alt="" src="@/assets/images/compare.jpg"  />
                                    <span class="ml-2 view text-dark mr-1">Ajouter au comparateur</span>
                                </div>

                            <div class="view">

                                
                            </div>

                        

                        
                            <!-- <img alt="" class="pr-2" src="../../../assets/images/view.svg" /> -->
                            
                            
                        </div>
                    </div>

                </div>

                <div v-if="product && product.sizes" class="col-md-3 text-left d-none d-xl-block">
                    <div class="thin-rectangle-div mt-1  mb-3" />
                    <div class="color mb-3 mt-1 font-size-16">Couleur <span class="text-dark">{{ this.selectedColor ? this.selectedColor.color.name : '' }}</span> </div>
                     <ColorComponent :sizesList="product.sizes" :selectedSize="selectedSize" @color-selected="updateSelectedColor" :isItemProfil = true ></ColorComponent> 
                </div>

                <div v-if="product && product.sizes" class="col-md-3 text-left d-none d-xl-block">
                    <div class="thin-rectangle-div mt-1 mb-3" />
                    <div class="color mb-3 mt-1 font-size-16">Tailles </div>   
                     <SizeComponent :sizes=product.sizes :selectedColor ="selectedColor" @size-selected="updateSelectedSize" :isItemProfil = true ></SizeComponent>
                
                        <div class="row mt-3 text-center" @click="showSizeGuide=true" style="width:80%; cursor:pointer;">
                            <div class="col-12">
                                <span class="font-size-16 text-dark"> <img alt="" class="mr-1" src="@/assets/images/view.svg" /> Guide des tailles</span>
                            </div>
                        </div>
                
                    </div>

                <div class="col-md-2 text-right d-none d-xl-block">
                    <button v-if="product && product.lookGroupCode" class="full-width-button" @click="showLook()">Voir le look</button>
            
                    <div class="row mt-3" >
                        <div class="col-6">
                            <div class="quantity-button">
                                <div class="content3">
                                    <div class="quantity-controls">
                                        <img class="iconminus" alt="" src="../../../assets/images/Minus.svg"
                                            @click="decrementQuantity()" />
                                        <div class="quantity-text">{{ this.quantity }}</div>
                                        <img class="iconadd" alt="" src="../../../assets/images/Add.svg"
                                            @click="incrementQuantity()" />
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div class="col-6">

                            <button class="btn btn-primary second-full-width-button" 
                                
                                @click="addToCart()">
                                Ajouter
                                
                            </button>
                            
                        </div>
                    </div>

                    <div class="row text-right">
                        <div class="col-12">
                              <span v-if="showSelectSizeColorMsg" class="text-warning font-weight-bold">Veuillez Sélectionner une taille et couleur</span>
                              <span v-if="selectedSize && selectedColor && selectedColor.color" class="font-size-14 text-dark font-weight-bold ml-2"> Taille :  {{ selectedSize  }}, couleur : {{ selectedColor && selectedColor.color ? selectedColor.color.name : '' }}</span>
                        </div>
                    </div>
                    
                </div>
            </div>


            

            
        <b-modal v-model="showSizeGuide" 
                title="Guide des Tailles" 
                centered hide-footer hide-header
                title-tag="h5"
                header-close-variant="danger"
                title-class="text-warning"
                size="xl">

                    <SizeGuide /> 

      </b-modal>
            
    </div>
        <!-- Show only on mobile -->
        <!-- <div class="d-md-none">
            <img alt="" src="../../../assets/images/product-image-mobile.png" />
        </div> -->
        <!-- Show only on mobile -->

        <div class="row mt-4 ">
            <div class="col-12">
                <ProductCard :product="product" :isProductPage="true" @open-look="showLook" class="d-xl-none" />

            </div>

        </div>
       
  
        <div class="ml-0 mr-0 ml-xl-4 mr-xl-4" >
        
            <div class="black-rectangle-div d-none d-md-block" />

            <Navigation class="d-none d-md-block" :section="section" :group="group" :subGroup="subGroup" ></Navigation>

            <div class="mt-4 pt-4">
                <div class="container">
                    <div class="row p-0 m-0 first-container">
                        <div class="col-12 col-md-3">
                            <div class="title-container ">


                                <div class="row" @click="showInfo()" :class="isShowRating ? 'grey-title' : 'product-ref-title'">
                                    <div class="col-10  col-lg-12 my-auto text-center text-md-left">
                                        <div  class="text-left mb-2 " >Ref Produit</div>
                                    </div>
                                    <div class="col-2 text-right d-md-none">
                                        <b-button  variant="outline" class="pr-0 pl-2" style="cursor: pointer;" >   
                                            <img  height="25px;"  alt="" src="@/assets/icons/chevron-down.svg" />     
                                        </b-button> 
                                    </div>
                                </div>

                                <div :class="isShowProductRefInMobile && !isShowRating ? '' : 'd-none'" class="row mb-4 mt-2 d-md-none">
                                    <div class="col-12">
                                         <!-- PRODUCT INFO for mobile -->
                                        <ProuductPageInfo v-if="!isShowRating" :product="product" />
                                    </div>
                                </div>
 
                                <div class="row mt-3 mt-md-3 mb-3 mb-lg-0" @click="showRating()" :class="isShowRating ? 'product-ref-title' : 'grey-title'">
                                    <div class="col-10 col-lg-12 my-auto text-center text-md-left">
                                        <div v-if="product && product.showRating"   class="text-left mb-2" >Avis clients {{ ratings && ratings.count ?  '(' + ratings.count + ')' : '' }} </div>
                                    </div>
                                    <div class="col-2 text-right d-md-none">
                                    <b-button  variant="outline" class="pr-0 pl-2" style="cursor: pointer;" >   
                                        <img  height="25px;"  alt="" src="@/assets/icons/chevron-down.svg" />     
                                    </b-button> 
                                    </div>
                                </div>
                                
                                <div class="row mt-3 mt-md-0 mb-3 mb-lg-0 d-none" :class="isShowRating ? 'product-ref-title' : 'grey-title'">
                                    <div class="col-10 col-lg-12 my-auto text-center text-md-left">
                                        <div v-if="product"   class="text-left mb-2" >Voir en magasin </div>
                                    </div>
                                    <div class="col-2 text-right d-md-none">
                                    <b-button  variant="outline" class="pr-0 pl-2" style="cursor: pointer;" >   
                                        <img  height="25px;"  alt="" src="@/assets/icons/chevron-down.svg" />     
                                    </b-button> 
                                    </div>
                                </div>                              

                            </div>
                        </div>

                        <!-- PRODUCT INFO for web -->
                        <ProuductPageInfo v-if="!isShowRating" class="col-md-9 d-none d-md-flex"  :product="product" />
 
                        <!-- PRODUCT RATING -->
                        <div v-if="isShowRating" class="col-md-8 mt-3 mt-md-0">
                            <div class="row mb-4">
                                <div class="col-12 col-md-6">
                                    <div class="font-size-18 font-weight-bold text-dark">Avis des clients </div>
                                    <span>Ajouté par des utilisateurs HA</span>
                                </div>

                                <div class="col-12 col-md-6 mt-3 mt-md-0">
                                    <StarRating :increment="0.5" :show-rating="false" :star-size="30"
                                    :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]" 
                                    v-model="ratings.rating"
                                    :read-only="true"/>
                                </div>
                            </div>

                            <div class="row mb-4">
                                <div class="col-12 col-md-6 mt-4 mt-md-0">
                                    <div class="font-size-18 font-weight-bold text-dark">Avis vérifiés
                                        <img  alt="" width="20px" class="ml-1 " src="../../../assets/icons/fi-rr-shield-check.svg"  />  
                                    </div>
                                    <span>Clients qui ont commandé le produit</span>
                                </div>

                                <div class="col-12 col-md-6 mt-3 mt-md-0">
                                    <StarRating :increment="0.5" :show-rating="false" :star-size="30"
                                    :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]" 
                                    v-model="ratings.ratingVerified"
                                    :read-only="true"/>
                                </div>
                            </div>

                            <div class="row mb-0 mb-md-4 pt-4">
                                <div class="col-12 col-md-6">
                                    <div class="font-size-20 font-weight-bold text-dark">Ajouter votre avis ? </div>
                                    <span class="font-size-14">Cliquez pour laisser un avis sur cet article</span>
                                </div>

                                <div class="col-12 col-md-6 mt-3 mt-md-0">
                                    <StarRating v-if="currentUser" :increment="0.5" :show-rating="false" :star-size="40"
                                    :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"   
                                    v-model="selectedRating"
                                    :read-only="false"/>

                                    <a v-if="!currentUser" class="text-secondary font-weight-bold" href="/login"><u> se connecter </u></a>
                                </div>
                            </div>
                            
                        </div>


                    </div>
                </div>
            </div>


            <div class="container">
                <div class=" second-container">
                     <div v-if=" equivalentItems && Object.keys(equivalentItems) && Object.keys(equivalentItems).length != 0 "  class="row mb-4">
                        <div class="col-9 ">
                            <span class="section-title ">Vous pourriez aussi aimer</span>
                            <b-spinner class="ml-2 mt-2" v-if="isGetEquivalentItemsStarting"  small variant="primary" role="status"></b-spinner>

                        </div>
                        

                        <div class="col-3 text-right">
                            <b-button class="p-0 m-0" variant="outline" style="cursor: pointer;" :disabled="equivalentPagemodel.currentPage == 1 "  @click="previousPage(equivalentItems)" >  <img   alt=""  width="18px"  src="@/assets/icons/fi-rr-angle-small-left.svg"  /> </b-button> 
                            <b-button class="p-0 m-0"  variant="outline" style="cursor: pointer;" :disabled="equivalentPagemodel.currentPage + equivalentPagemodel.perPage > equivalentPagemodel.totalRows  || equivalentPagemodel.totalRows <=equivalentPagemodel.perPage "  @click="nextPage(equivalentItems)"> <img   alt=""  width="18px"  src="@/assets/icons/fi-rr-angle-small-right.svg"  />  </b-button>
  
                        </div>
                       

                    </div>

                    <div v-if=" equivalentItems && Object.keys(equivalentItems) && Object.keys(equivalentItems).length != 0 "  class="row mb-4">
                        <div class="col-12 col-md-3 pr-0 pr-md-4" v-for="(product, index) in equivalentItems" :key="index">
                          <router-link :to="'/catalogue'+product.url"  >
                            <productCardInproductPage :product="product" />
                         </router-link>  
                        </div>
                    </div>
                    


                     <div  v-if=" complementItems && Object.keys(complementItems) && Object.keys(complementItems).length != 0" >
                        <div style="margin-top: 10%;">
                            <div class="row mb-4 mt-4">
                                <div class="col-9  ">
                                    <span class="section-title">Articles complémentaires</span>
                                    <b-spinner class="ml-2 mt-2" v-if="isGetComplementItemsStarting"  small variant="primary" role="status"></b-spinner>
                                </div>
                                

                                <div class="col-3 text-right">               
                                    <b-button class="p-0 m-0" variant="outline" style="cursor: pointer;" :disabled="complementPagemodel.currentPage == 1 " @click="previousPage(complementItems)" >  <img  alt="" width="18px" class="" src="@/assets/icons/fi-rr-angle-small-left.svg"  />   </b-button> 
                                    <b-button class="p-0 m-0" variant="outline" style="cursor: pointer;" :disabled="complementPagemodel.currentPage + complementPagemodel.perPage > complementPagemodel.totalRows || complementPagemodel.totalRows <=complementPagemodel.perPage" @click="nextPage(complementItems)">  <img width="18px" alt="" src="@/assets/icons/fi-rr-angle-small-right.svg"  />  </b-button>
                                </div>

                                </div>
                            </div>
                        </div>
                        <div v-if=" complementItems && Object.keys(complementItems) && Object.keys(complementItems).length != 0" class="row mt-4">
                            <div class="col-md-3 pr-0 pr-md-4" v-for="(product, index) in complementItems" :key="index">
                                <router-link :to="'/catalogue'+product.url"> 
                                    <productCardInproductPage :product="product" />
                                </router-link>
                            </div>
                        </div>
                    </div>
                
            </div>

            
            <div class="container">
                <div class="row mt-3 ">

                    <div class="col-12">
                        <hr />
                    </div>

                    <div class="col-6 text-dark font-weight-bold text-left">
                        Partager sur les réseaux sociaux
                    </div>
                    
                    <div class="col-6 text-right">
                    <!-- Facebook share button -->
                        <a :href="`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`" target="_blank">
                            <b-button pill class="mr-2 border border-light social-sharing social-share" size="sm" variant="white" title="Partager sur Facebook" style="">
                                <img  alt="" width="20px" class="p-0" src="../../../assets/icons/facebook.svg"  />  

                            </b-button>
                        </a>
                        <!-- Instagram share button -->
                        <a :href="`https://www.instagram.com/?url=${currentUrl}`" target="_blank">
                            <b-button pill class=" border border-light social-sharing social-share" size="sm" variant="white" title="Partager sur Instagram" style="">
                                <img  alt="" width="20px" class="p-0" src="../../../assets/icons/instagram.svg" />  
                            </b-button>
                        </a>
                                    
                    </div>
                </div>
            </div>

        </div>


        <div v-if="showZoomImage" @click="showZoomImage= false" @keydown="onZoomKeyDown" tabindex="0" ref="zoomDiv" @mousemove="handleMouseMove" class="image-zoom-container  visible">
            <img v-show="!isHdBigImageLoaded" class="big-image-full" v-bind:src="'/api/image/get/product/small/' + this.urlImage"  alt="">
            <img v-show="isHdBigImageLoaded" @load="onHdBigImageLoad()" class="active-big-image big-image-full" v-bind:src="'/api/image/get/product/' + this.urlImage"  alt="">
        </div>
        
    </Layout>
</template>

<style scoped>

.big-image-full {
    position: relative; 
    top: 0; 
    left: 0; 
    width: 100%;
    overflow: scroll;
    margin: auto; 
    opacity: 1;
}

.social-share:hover {
    background-color: #fff;
}

.social-share:hover i {
    color: #fff !important;
}

#floatingDiv {
  position: fixed;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  background-color: lightgray;
  padding: 10px;
  border-radius: 5px;
}

.slide-enter-active, .slide-leave-active {
  transition: transform 0.5s ease;
}

.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}

.product-image {
    height: calc(100% + 8px);       
    width: auto;     
    object-fit: cover; 
    transition: transform 1s ease-in-out;
}

.image-container {
  position: relative;
  display: inline-block;
  width:100%;
  height:100%;
  background-color:#0000004d;
}

.spinner-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  opacity: 1;
}


.icon-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  opacity: 0;
}

.image-container:hover .icon-container {
  opacity: 1;
}

.image-container:hover .product-image {
    transform: scale(1.05);
}








.image-zoom-container {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    /*overflow: auto; */ /* Enable scrolling */
    overflow-y: scroll;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, .3);
    user-select: none;
    visibility: hidden;
    opacity: 0;
    cursor: url(data:image/png;base64,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) 51 51, zoom-out;
}

.image-zoom-container {
    visibility: visible;
    opacity: 1;
}


















.description {
    position: absolute;
    top: calc(50% - 16px);
    left: 0px;
    letter-spacing: -0.4px;
    line-height: 32px;
    font-weight: 500;
    display: inline-block;
    width: 303px;
}

.iconchevron-up {
    position: absolute;
    top: calc(50% - 12px);
    right: 0px;
    width: 24px;
}

.content1 {
    position: relative;
    height: 32px;
}

.content {
    border-bottom: 1px solid #121212;
    padding: 0px 0px 8px;
}

.elementstabstitle-buttons {
    box-sizing: border-box;
    text-align: left;
    font-size: 18px;
    color: #121212;
    font-family: 'Space Grotesk';
}


.paste-image-icon {
    position: relative;
    width: 100%;
    max-height: 100%;
    object-fit: fill;
    object-position: center top;
}

.titleClass {
    font-weight: 500;
    font-family: 'Space Grotesk';
    color: #121212;
}

.iconheart {
    position: relative;
}

/* Styles for web */
@media (min-width: 768px) {
    .titleClass {
        font-size: 28px;
        letter-spacing: -0.6px;
    }


}

/* Styles for mobile */
@media (max-width: 767px) {
    .titleClass {
        font-size: 24px;
        /* Adjust the font size for mobile */
        letter-spacing: -0.4px;
        /* Adjust other styles as needed */
    }

  
}

.price {
    position: relative;
    font-weight: 600;
    font-family: Inter;
    color: #121212;
    text-align: left;
}

.discount-pill {
    display: inline-block;
    border-radius: 20px;
    font-weight: bold;
}

/* Styles for web */
@media (min-width: 768px) {
    .price {
        font-size: 26px;
    }

    .discount-pill {
        background: #ff0000;
        color: #ffffff;
        padding: 3px 10px 3px 11px;
        /*line-height: 26px;*/

        font-weight:bold !important;
        font-size: 14px;
        
    }
}

/* Styles for mobile */
@media (max-width: 767px) {
    .price {
        font-size: 18px;
    }

    .discount-pill {
        background: #ff0000;
        color: #ffffff;
        padding: 6px 10px;
        font-size: 12px;
    }
}

.old-product-price {
    font-size: 18px;
    text-decoration: line-through;
    font-family: Inter;
    color: #a7a7a7;
}

.view {
    /*flex: 1;*/
    width: 100%;
    /*position: relative;*/
    font-size: 16px;
    line-height: 26px;
    font-family: Inter;
    color: #121212;
    text-align: left;
    display: inline-block;
}

.color {
    width: 100%;
    position: relative;
    font-size: 12px;
    line-height: 20px;
    font-weight: 600;
    font-family: Inter;
    color: #605f5f;
    text-align: left;
    display: inline-block;

}

.black-rectangle-div {
    position: relative;
    background-color: #000;
    width: 100%;
    height: 3px;
    margin-top: 3%;
}

.thin-rectangle-div {
    position: relative;
    background-color: #D3D3D3;
    width: 80%;
    height: 0.1px;

}

.quantity-button {
    width: 100%;
    background-color: #f5f5f5;
    font-size: 18px;
    line-height: 26px;
    font-weight: 600;
    font-family: 'Inter', sans-serif;
    color: #121212;
    border: none;
    padding: 10px;
    cursor: pointer;
    height: 60px;
    /* Adjust the height as needed */
    display: flex;
    align-items: center;
    justify-content: center;
}

.content3 {
    position: absolute;
    border-radius: 4px;
    background-color: #f5f5f5;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.quantity-controls {
    display: flex;
    align-items: center;
}

.iconminus,
.iconadd {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.quantity-text {
    line-height: 20px;
    font-weight: 600;
    margin: 0 8px;
    font-size: 18px;

}

.quantity-button {
    width: 100%;
    background-color: #f5f5f5;
    height: 60px;
    /* Adjust the height as needed */
}

.full-width-button {
    width: 100%;
    background-color: #f5f5f5;
    font-size: 16px;
    line-height: 26px;
    font-weight: 600;
    font-family: 'Inter', sans-serif;
    color: #121212;
    border: none;
    padding: 10px;
    cursor: pointer;
    height: 60px;
    /* Adjust the height as needed */
    display: flex;
    align-items: center;
    justify-content: center;
}

.second-full-width-button {
    width: 100%;
    background-color: #121212;
    font-size: 16px;
    line-height: 26px;
    font-weight: 600;
    font-family: 'Inter', sans-serif;
    color: #f5f5f5;
    border: none;
    padding: 10px;
    cursor: pointer;
    height: 60px;
    /* Adjust the height as needed */
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius:0px;
}

.thin-gerey-rectangle-div {
    position: relative;
    background-color: #fbfbfb;
    width: 98%;
    height: 12px;
}

.thick-grey-rectangle-div {
    position: relative;
    background-color: #cdcdcd;
    width: 2%;
    height: 12px;
}

.categories-title {
    position: relative;
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    font-family: 'Space Grotesk';
    color: #828282;
    text-align: left;
    margin-left: 5%;
    margin-top: 2%;
}

.product-ref-title {
    display: inline-block;
    border-bottom: 1px solid #121212;
    box-sizing: border-box;
    font-size: 20px;
    color: #121212;
    font-family: 'Space Grotesk';
    font-weight: bold;
    cursor: pointer;
}

@media screen and (max-width: 767px) {
    .product-ref-title {
        display: flex;
        width:100%;
    }
}

.grey-title {
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    font-family: 'Space Grotesk';
    color: #807e7e;
    cursor: pointer;
}

@media screen and (max-width: 767px) {
    .grey-title {
        display: flex;
        width:100%;
        color: #121212;
        border-bottom: 1px solid #121212;
    }
}

.reference {
    font-size: 18px;
    line-height: 30px;
    display: inline-block;
    font-family: Inter;
    color: #3e3e59;
}

.information {
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    font-family: 'Space Grotesk';
    color: #121212;
}

.brands-title {
    font-size: 18px;
    line-height: 30px;
    color: #525252;
    font-family: Inter;
}

.first-container {
    margin: 4%;
}

.second-container {
    margin: 4%;
    margin-top: 10%;
}

/* Styles for mobile */
@media (max-width: 767px) {
    .second-container {
        margin: 0%;
        margin-top: 15%;

    }

}

.section-title {
    font-size: 22px;
    font-family: 'Space Grotesk';
    color: #121212;
}

@media (max-width: 767px) {
    .section-title {
        font-size: 16px;
        font-family: 'Space Grotesk';
        color: #121212;
    }
}

.arrow-icons {
    display: flex;
    gap: 10px;
    margin-left: auto;

}

.compareIcon {
    position: relative;
    width: 16px;
    height: 16px;
    overflow: hidden;
    flex-shrink: 0;
}

.compare-wrapper {
    height: 5.79%;
    
    border-radius: 60px;
    background-color: #fff;
    border: 0.5px solid #e2e2e2;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 5px;
    cursor: pointer;
}

.compare-wrapper:hover .view {
    font-weight:bold;
}

.discountLabel-max {
    /*position: relative;*/
    /*margin-left: 0.71%;*/
    border-radius: 8px;
    background-color: #ff0000;
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
    color: #fff;
    padding: 2px 8px 2px 8px;
}

@media screen and (min-height: 860px) {

    .images-zone-size {
        height: calc(100vh - 25vh - 40px);
    }

    .title-zone-size {
        height: calc(25vh - 40px);
    }
}

@media screen and (max-height: 859px) {

.images-zone-size {
    height: calc(100vh - 30vh - 40px);
}

}


</style>
